import { cents } from "../filters/number";

function isMultiple(val, args) {
  const multiple = parseInt(args[0]);

  if (!multiple) return false;

  const value = parseInt(val.toString().replace(/[^0-9]/g, ""));

  return value % multiple === 0;
}

export default {
  messages: {
    en: (field, args) => {
      let min = args[0];
      return `Valor deve ser múltiplo de ${cents(min)}`;
    },
    "pt-BR": (field, args) => {
      let min = args[0];
      return `Valor deve ser múltiplo de ${cents(min)}`;
    },
  },
  validate(value, args) {
    return isMultiple(value, args);
  },
};



// WEBPACK FOOTER //
// ./src/validators/is-multiple.js